import { Info } from "lucide-react";

import { Tooltip } from "@/components/ui/tooltip";

/**
 * Inline ⓘ affordance that reveals a row's description in a tooltip instead
 * of wrapping it under the name. Keeps list rows to a single line — the same
 * pattern used on the Workflows page. Renders nothing when there's no text.
 */
export function DescriptionTooltip({ text }: { text?: string | null }) {
  if (!text) return null;
  return (
    <Tooltip content={text} side="right">
      <span
        tabIndex={0}
        aria-label={`Description: ${text}`}
        className="shrink-0 text-muted-foreground/60 transition hover:text-foreground focus:text-foreground focus:outline-none"
      >
        <Info className="h-3.5 w-3.5" strokeWidth={1.5} />
      </span>
    </Tooltip>
  );
}
